module.exports = __webpack_public_path__ + "img/mastercard-icon-trimmed.71678d8.png";